// @ts-strict-ignore
import {ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {LMFieldBaseComponent} from '@field/lm-field-base.component';
import {LMModel, LMModelChangedEvent} from '@form/model';
import {LMFieldServiceAdapter} from '@field/lm-field-service-adapter';
import {AppConstants, LMCommonUtilService} from '@utils/index';
import {BehaviorSubject} from "rxjs";

@Component({
  selector:    'lm-progress',
  standalone: false,
  templateUrl: './lm-progress.component.html',
  styleUrls:   [ 'lm-progress.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMProgressComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  @Input() layoutObject: LMProgressLayout;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;

  public chartDataSet: SohoDataSet = null;
  public labelText = '';
  public chartData$ = new BehaviorSubject(null);

  private oldValue;

  constructor(protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    private lmCommonUtilService: LMCommonUtilService) {
    super(lmFieldServiceAdapter);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);
    this.setFieldClasses();

    this.oldValue = this.modelField.value;
    this.transformOptions.displayZero = true;

    this.buildDataSet();

    this.subscriptionArray.push(this.model.modelChanged
      .subscribe((modelChangedEvent: LMModelChangedEvent) => {
        // need to run back into ngZone as subscription is not in the zone
        this.lmFieldServiceAdapter.ngZone.run(() => {
          // do not set triggerValue here
          if (modelChangedEvent.eventType === 'set') {
            this.buildDataSet();
          }
        });
      })
    );

    this.subscriptionArray.push(this.modelField.valueChanged.subscribe((value) => {
      if (this.oldValue !== value) {
        this.oldValue = value;
        this.buildDataSet();
      }
    }))

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
  }

  // ngDoCheck() {
  //   // this is here in case an input field is also bound with the same bindId as
  //   // the progress bar; if it is, we want to update the chart
  //   if (this.oldValue !== this.modelField.value) {
  //     this.oldValue = this.modelField.value;
  //     this.buildDataSet();
  //   }
  // }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  }

  private buildDataSet() {
    const color = this.lmCommonUtilService.getRangeColor(this.field.ranges, this.modelField.value, this.model);
    const displayValue = this.lmFieldServiceAdapter.lmFormatUtilService.toDisplayValue(this.modelField.value, this.specField.type, this.transformOptions);
    let completedText;

    // Progress bar rules:
    // For a PERCENT field, only show "<value> of <meter>" IF the meter isn't 100% (the default).
    // For all else, show "<value> of <meter>" on the bar.

    // set meter, completed text, completed value
    // LPL meter directive not required for PERCENT; safety here for NUMERIC and BCD
    const meter = (this.field.meterRangeField)
      ? this.model.getField(this.field.meterRangeField).value
      : (this.field.meterRangeValue)
        ? this.field.meterRangeValue
        : (this.specField.type === AppConstants.PERCENT)
          ? 1.00
          : 100;

    // eslint-disable-next-line eqeqeq
    if (this.specField.type === AppConstants.PERCENT && meter == 1.00) {
      completedText = displayValue;

    } else {
      const displayMeter = this.lmFieldServiceAdapter.lmFormatUtilService.toDisplayValue(meter, this.specField.type, this.transformOptions);
      completedText = this.lmFieldServiceAdapter.lmFormatUtilService.formatMessage(Soho.Locale.translate('ValueOfMeter'), [ displayValue, displayMeter ]);
    }

    // completedValue is the style width attribute; cannot be localized
    const completedValue = this.modelField.value;

    this.labelText = this.labelResourceValue ? this.lmFieldServiceAdapter.lmFormatUtilService.formatMessageRule(this.labelResourceValue, this.model, this.specFields) : ''

    const chartData: SohoChartData = {
      name: { text: this.labelText },
      remaining:   {
        value: '',                        // removes value at top right of chart
        text:  ''
      },
      info:        {
        value: displayValue               // value for display
      },
      completed:   {
        value: completedValue,            // style width attribute; cannot be localized
        // text:  completedText,             // for targeted-achievement, places value at bottom left
        color
      },
      total:       {
        value: meter
      },
      percentText: {
        show: true,
        text: completedText               // places value in the chart; this.modelField.value
      }
    };

    const chartDataSetItem: SohoDataSetItem = {
      data: [ chartData ]
    };

    this.chartData$.next([ chartDataSetItem ])
    // this.chartDataSet = [ chartDataSetItem ];
  }
}
